// month-format.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const BAD_FORMAT = 'badFormat';

/**
 * Validator that checks if the control's value is a valid month.
 * Accepts either "3" or "03" for March, etc.
 */
export function monthFormatValidator(): ValidatorFn {
  const isMonthFormatValid = (value: string) => {
    // If the control is empty, let the required validator handle it.
    if (!value) {
      return true;
    }

    // Regular expression to match months 1-12.
    // Matches either a one-digit month (1-9) with an optional leading zero or a two-digit month (10-12).
    const monthRegex = /^(0?[1-9]|1[0-2])$/;

    if (!monthRegex.test(value)) {
      return false;
    }

    return true;
  };

  return (control: AbstractControl): ValidationErrors | null => {
    const valid = isMonthFormatValid(control.value);
    return !valid ? { [BAD_FORMAT]: true } : null;
  };
}
